import React from 'react';
import {observable, computed, action} from 'mobx';
import confirmationDialog from '../model/ConfirmationDialog';
import translateBase from '../translate';
let translate = translateBase.bindPage('authentication');

const AUTH_TIMEOUT = 15*60*1000;

export class Authentication {
  @observable authenticatedUser = {};
  @observable isUserLoaded = false;

  constructor(flasher, api, loginForm, rentalTransaction, organization) {
    this.flasher = flasher;
    this.api = api; 
    this.loginForm = loginForm;
    this.rentalTransaction = rentalTransaction;
    this.organization = organization;

    this.api.chnRequestStarted.subscribe(() => {
      this.resetAuthTimingOut();
    })
  }

  @computed get loggedIn() {
    return Boolean(this.authenticatedUser.Id);
  }

  @computed get userName() {
    return this.authenticatedUser.AccountUsername;
  }

  @computed get userId() {
    return this.authenticatedUser.Id;
  }  

  authTimeout = undefined;
  
  @action.bound startAuthTimingOut() {
    if(this.authTimeout !== undefined) {
      clearTimeout(this.authTimeout);
    }
    this.authTimeout = setTimeout(() => {
      this.authTimeout = undefined;
      this.logoutByTimeout();
    }, AUTH_TIMEOUT)
  }

  @action.bound resetAuthTimingOut() {
    if(this.authTimeout !== undefined) {
      clearTimeout(this.authTimeout);
      this.authTimeout = setTimeout(() => {
        this.authTimeout = undefined;
        this.logoutByTimeout();
      }, AUTH_TIMEOUT)      
    }
  }

  @action.bound stopAuthTimingOut() {
    if(this.authTimeout !== undefined) {
      clearTimeout(this.authTimeout);
    }
  }

  @action.bound logoutByTimeout() {
    this.logout();
    window.location.assign("#/home");
    confirmationDialog.confirm([
      <div className="confirmation-message-item">{translate("loggedOutDueToInactivity", "Infolge Inaktivität wurden Sie abgemeldet.")}</div>
    ], [{label: "OK", value: "true", className: "button-ok"}]);
  }

  @action.bound async login(setAsLessee) {
    try {
      this.flasher.setOther('Login.')
        if(setAsLessee || this.rentalTransaction) {
          const orgId = this.organization.id;
          const trxId = this.rentalTransaction.id;
          await Promise.all([
            this.rentalTransaction.setCurrentUserAsLessee({orgId, trxId}),
            this.rentalTransaction.fetch({orgId, trxId})
          ]);
        }
        await this.loadAuthenticatedUser();
        this.startAuthTimingOut();
    }
    finally {
      this.flasher.setOther()
    }
  }  

  // @action.bound async login(setAsLessee) {
  //   const userName = this.loginForm.values.userName;
  //   const password = this.loginForm.values.password;
  //   this.loginForm.reset({userName: '', password: ''});
  //   try {
  //     this.flasher.setOther('Login.')
  //     const loginResult = await this.api.login({
  //       username: userName,
  //       password: password,
  //     });
  //     if(loginResult.Status !== 200) {
  //       this.flasher.reportError('Login', loginResult.Message);
  //     } else {
  //       if(setAsLessee || this.rentalTransaction) {
  //         const orgId = this.organization.id;
  //         const trxId = this.rentalTransaction.id;
  //         await Promise.all([
  //           this.rentalTransaction.setCurrentUserAsLessee({orgId, trxId}),
  //           this.rentalTransaction.fetch({orgId, trxId})
  //         ]);
  //       }
  //       await this.loadAuthenticatedUser();
  //       this.startAuthTimingOut();
  //     }
  //   }
  //   finally {
  //     this.flasher.setOther()
  //   }
  // }

  @action.bound async logout() {
    try {
      this.flasher.setOther('Logout.');      
      this.authenticatedUser = {};
      this.stopAuthTimingOut();
      await window.OidcMgr.signoutRedirect();
      //await this.api.logout();
    }
    finally {
      this.flasher.setOther();      
    }
  }

  @action.bound async loadAuthenticatedUser() {
    this.authenticatedUser = (await this.api.getAuthenticatedUser(this.organization.id)) || {};
    if(this.authenticatedUser.AccountUsername) {
      this.startAuthTimingOut();
    }
    this.isUserLoaded = true;
  }

}


// WEBPACK FOOTER //
// ./src/model/Authentication.js